import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d7b7ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "enroll-popup-head-warp" }, "接单信息", -1))
const _hoisted_2 = { class: "enroll-form-warp" }
const _hoisted_3 = { class: "enroll-text-input-warp" }

import { ref } from 'vue';
import { Toast } from 'vant'

import { postHelpOrder } from "@/api/NeighborHelpOrder";


export default /*#__PURE__*/_defineComponent({
  __name: 'mutualAidGetOrder',
  emits: ["getOrderSuccess"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit


const enroll = ref({
    showPopup: false,
    placeholder: "请输入您的留言",
    form: {
        userName: "",
        phone: "",
        memo: "",
        signUpTime: 0,
        activityId: "",

        helpId: "",
        helpOrderStatus: 0,
        cancelReason: "",
        loveHelpPublishType: 0,
    },
});

const data = ref({
    id: "",
    content: "",
    title: "",
    headUrl: "",
    userName: "",
    createTimeStamp: new Date(1666007599403),
    watchCount: 0,
    LoveHelpPublishType: 0,
    contactUser: "",
    phone: "",
    targetAddress: "",
    helpStatus: 0,
    isMy: false,
    neighborActivityStatus: 0,
    actHostUser: 0,
    startActTime: 0,
    endActTime: 0,
    isSignUp: false,
    payPoint: 0,
    province: "",
    city: "",
    district: "",
    address: "",
})


const submitActSignUp = async () => {

    let mobile = /^1[0-9][0-9]\d{8}$/;
    let errorMessage = "";
    if (enroll.value.form.userName.trim().length == 0) {
        errorMessage = "请输入姓名";
    }
    if (!mobile.test(enroll.value.form.phone)) {
        errorMessage = "请填写正确的手机号码";
    }
    if (errorMessage != "") {
        Toast.fail(errorMessage);
        return;
    }
    enroll.value.form.signUpTime = new Date().getTime();
    enroll.value.form.helpId = data.value.id;
    enroll.value.form.helpOrderStatus = 1;
    enroll.value.form.cancelReason = "";
    enroll.value.form.loveHelpPublishType = 0;


    var isokLoveHelp = await postHelpOrder(enroll.value.form);
    if (isokLoveHelp) {
        Toast.success(`接单成功`);
        enroll.value.showPopup = false;
        emit('getOrderSuccess');
        // this.loadData();
    } else {
        Toast.fail('接单失败');
    }

}

const setCurData = (newData: any) => {
    data.value = newData;
}

const showAlert = () => {
    enroll.value.showPopup = true;
    resetForm();
}

const hideAlert = () => {
    enroll.value.showPopup = false;
}

const resetForm = () => {
    enroll.value.form.userName = '';
    enroll.value.form.phone = '';
    enroll.value.form.memo = '';
}

__expose({
    setCurData,
    showAlert,
    hideAlert
})




return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    teleport: "body",
    show: enroll.value.showPopup,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((enroll.value.showPopup) = $event)),
    round: "",
    closeable: "",
    "close-icon": "close",
    position: "bottom"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_cell_group, {
          class: "enroll-cell-group",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              modelValue: enroll.value.form.userName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((enroll.value.form.userName) = $event)),
              label: "姓名",
              placeholder: "请输入姓名"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: enroll.value.form.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((enroll.value.form.phone) = $event)),
              label: "联系电话",
              placeholder: "请输入联系电话"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, { label: "备注留言" }, {
              input: _withCtx(() => []),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_van_field, {
                modelValue: enroll.value.form.memo,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((enroll.value.form.memo) = $event)),
                rows: "1",
                class: "enroll-text-input",
                type: "textarea",
                maxlength: "100",
                placeholder: enroll.value.placeholder,
                "show-word-limit": ""
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (submitActSignUp())),
          type: "primary",
          block: "",
          color: "#FD5C02"
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认报名")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})